import type { BlockExport } from "@/react/components/shared/BuilderUI/BuilderUI.types";
import { FormHeadingBlock as Block } from "./FormHeadingBlock";
import { defaultData } from "./FormHeadingBlockDefaultData";
import { meta } from "./FormHeadingBlockMetaData";

export const FormHeadingBlock: BlockExport = {
  type: "component",
  Block,
  defaultData,
  imagePreview: {
    type: "icon",
    name: "24-builder-ui-element-heading",
    size: 24,
  },
  meta,
};
